export const DESIGN_THEME_STORAGE_KEY = 'cntrct_design_theme';

export const DESIGN_THEMES = {
  style1: {
    id: 'style1',
    label: 'סגנון 1 – קלאסי',
    description: 'העיצוב הקיים עם תפריט צד ותמונת רקע',
    layout: 'sidebar',
  },
  style2: {
    id: 'style2',
    label: 'סגנון 2 – מינימלי',
    description: 'תפריט צד צר ונקי, צבעים מודרניים וגלישת טקסט',
    layout: 'sidebar',
  },
  style3: {
    id: 'style3',
    label: 'סגנון 3 – תפריט עליון',
    description: 'ניווט אופקי בראש המסך',
    layout: 'topnav',
  },
  style4: {
    id: 'style4',
    label: 'סגנון 4 – טרבלסי קרמיקה כהה',
    description: 'עיצוב כהה ומודרני בגווני הלוגו',
    layout: 'sidebar',
    ceramic: true,
  },
  style5: {
    id: 'style5',
    label: 'סגנון 5 – טרבלסי קרמיקה בהיר',
    description: 'תפריט צד צר בסגנון toolbar, רקע נקי בגווני הלוגו',
    layout: 'sidebar',
    ceramic: true,
  },
};

export const DEFAULT_DESIGN_THEME = 'style1';

export const getDesignThemeMeta = (themeId) => (
  DESIGN_THEMES[themeId] || DESIGN_THEMES[DEFAULT_DESIGN_THEME]
);

export const isTopNavTheme = (themeId) => getDesignThemeMeta(themeId).layout === 'topnav';

export const isCeramicTheme = (themeId) => Boolean(getDesignThemeMeta(themeId).ceramic);
